import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=6b096782&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=6b096782&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b096782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b096782')) {
      api.createRecord('6b096782', component.options)
    } else {
      api.reload('6b096782', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=6b096782&scoped=true", function () {
      api.rerender('6b096782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Meet/Pagination.vue"
export default component.exports